export function formatAddress(streetName, streetNumber, cityName) {
  return streetName ? `${streetName} ${streetNumber}, ${cityName}` : cityName;
}
